import React from "react"
import PropTypes from "prop-types"

/** Conmutador de dos posiciones, como el «Importe / Piezas y Kgs» del diseño. */
const SegmentedToggle = ({ opciones, valor, onChange }) => (
  <div className="res-seg">
    {opciones.map(opcion => (
      <button
        key={opcion.id}
        type="button"
        className={valor === opcion.id ? "is-active" : ""}
        onClick={() => onChange(opcion.id)}
      >
        {opcion.titulo}
      </button>
    ))}
  </div>
)

SegmentedToggle.propTypes = {
  opciones: PropTypes.array.isRequired,
  valor: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default SegmentedToggle
